import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';
import PATH_PAGE from '@/router/path';
import { AlignStartVertical } from 'lucide-react';
import { Link } from 'react-router-dom';

const DisplayQuotaLimit = () => {
  return (
    <>
      <Alert variant="info">
        <AlignStartVertical className="h-4 w-4" />
        <AlertTitle className="first-letter:uppercase">Your quota is full.</AlertTitle>
        <AlertDescription>
          Please go to your{' '}
          <Link to={PATH_PAGE.setting.serviceQuota} className="underline">
            service quota.
          </Link>
        </AlertDescription>
      </Alert>
    </>
  );
};

export default DisplayQuotaLimit;
